<nz-tabset
  nzLinkRouter
  [nzType]="'card'"
  [nzTabBarGutter]="7"
  [class.has-currency]="cut === 'STD' || cut === 'NMV'"
  [(nzSelectedIndex)]="selectedTabIndex"
>
  <nz-tab *ngFor="let tab of mexGridTabs">
    <a
      [routerLink]="tab.link"
      routerLinkActive="selected-tab"
      *nzTabLink
      nz-tab-link
      nzPopoverContent=".{{ tab.shortName }} - {{ tab.label }}"
      nzPopoverPlacement="bottom"
      nz-popover
      [nzPopoverOverlayStyle]="{ 'font-size': '12px' }"
      class="mex-tab-router-links"
    >
      {{ tab.label }}
    </a>
  </nz-tab>
</nz-tabset>
<va-currency-select
  class="currency-select-mex"
  *ngIf="cut === 'STD' || cut === 'NMV'"
  size="small"
  selectWidth="140"
  labelPlacement="left"
  [bottomBorderView]="true"
  [selectedCurrency]="selectedCurrency"
  [apiEP]="apiEP"
  apiUrl="/api/get_available_currencies"
  (onChange)="currencyChange($event)"
></va-currency-select>
<app-mex-grid-table
  style="width: 100%"
  (onCurrencySet)="onMEDataCurrencySet($event)"
></app-mex-grid-table>
